import { MouseEvent } from "react";

import { useTranslation } from "next-i18next";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { useAskSeller } from "@/components/ProductDetail/hooks/useAskSeller.hooks";
import ProductUtils from "@/components/ProductDetail/utils/ProductUtils";
import useMerchant from "@/hooks/useMerchant";
import { Button } from "@/ui/cva/Button";

type ProductDetailsInfoSellerContactProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoSellerContact = ({
  product,
}: ProductDetailsInfoSellerContactProps) => {
  const { t } = useTranslation();

  const { askSeller } = useAskSeller(product);
  const { id: userId } = useMerchant();

  const isProductOwner = product.merchant.id === userId;
  const isSold = ProductUtils.isSold(product);
  const vacationMode = !!product.merchant.vacationModeEnabledAt;
  const disableContactSeller = product.merchant.disableContactSeller;

  const handleContactSellerClick = async (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    await askSeller();
  };

  if (isProductOwner || disableContactSeller) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-2">
      <Button
        disabled={isSold || vacationMode}
        appearance="outlined"
        onClick={handleContactSellerClick}
      >
        {t("pdp:pdp-seller-block-contact")}
      </Button>
    </div>
  );
};
